import {Alert, Box, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function TabTopProducts({tabValue}) {
    const {t} = useTranslation();
    return <div role="tabpanel" hidden={tabValue !== 2} id="pharmacy-tabpanel-2" aria-labelledby="pharmacy-tab-2">
        {tabValue === 2 && <Box>
            <Typography variant="h6" gutterBottom>{t("TopProducts")}</Typography>
            <Alert severity="info">{t("DistributorRankingsUnavailable")}</Alert>
        </Box>}
    </div>;
}
